import { Button, ContainerFixedMargin } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import React from 'react';

import { Footer, FooterSecondary, Header } from '../../components';

export const OnlyDesktop = ({ show }: { show?: ['foot-sec', 'footer'] }): JSX.Element => {
  const router = useRouter();
  return (
    <div>
      <Header />
      <ContainerFixedMargin className="mobile:py-90">
        <div className="flex flex-col items-center justify-center">
          <img
            className="mb-32"
            style={{ height: '70%', width: '70%' }}
            src="https://res.cloudinary.com/samvibes/image/upload/v1626080930/landing/lucy_onlydesktop.png"
            alt="lucy_desktoponly"
          />
          <div className="text-center font-bold">
            <p className="mb-16 text-blue-800 text-2xl">
              Uh oh, Sketchnote is currently available on desktops only
            </p>
            <p className="mb-16 text-blue-500 text-lg">Check back soon for a mobile version!</p>
            <Button aria-label="go-back" status="primary" size="lg" onClick={() => router.back()}>
              Go back
            </Button>
          </div>
        </div>
      </ContainerFixedMargin>
      {show?.includes('foot-sec') ? <FooterSecondary /> : null}
      {show?.includes('footer') ? <Footer /> : null}
    </div>
  );
};
